module.exports = __webpack_public_path__ + "ed929c71e2feacdd5b0b427436227408.pdf";